export default __webpack_public_path__ + "static/media/1855.00fdbbf5.png";